module.exports = __webpack_public_path__ + "img/Distribution-of-Packages-by-Continent-1080x926.58034d94.png";